import styled from "styled-components";
import MusicalNoteGif from "./musicalnote.gif"
import { ThemeListRo } from "./ThemeListRo";
import { use, useContext, useState } from "react";
import PlaySimbolWhite from "./play_arrow_white.png"
import PlaySimbolBlack from "./play_arrow_black.png"
import PauseSimbolWhite from "./pause_white.png"
import PauseSimbolBlack from "./pause_black.png"
import { set } from "react-hook-form";
import { PageContext } from "../Context/PageContext";
import TopRagnarok from "../VoteBanners/TopRagnarok";
import TopRagnarokBrasil from "../VoteBanners/TopRagnarokBrasil";

var audio = new Audio();

audio.volume = 0.5;

function MusicPlayerMedia() {

    const { musicDuration, setMusicDuration } = useContext(PageContext)
    const { musicDurationTimeLeft, setMusicDurationTimeLeft} = useContext(PageContext)
    const { musicName, setMusicName } = useContext(PageContext)
    const { musicNumber, setMusicNumber } = useContext(PageContext)
    const { controlObject, setcontrolObject } = useContext(PageContext)
    const [playingState, setPlayingState] = useState(false)



    var i = setInterval(() => {

            let time = musicDuration.split(":")
            let min = parseInt(time[1]);
            let sec = parseInt(time[2]);
            let total = min * 60 + sec;
            let totalLeft = total - Math.trunc(audio.currentTime);

            min = String(Math.trunc(totalLeft/60)).padStart(2, "0");
            sec = String(totalLeft%60).padStart(2, '0');
            
            
           //setMusicDurationTimeLeft(Math.floor((1 - audio.currentTime/total)*100));
           setMusicDurationTimeLeft(`${min}:${sec}`);

            if(audio.ended || audio.paused) {
                setcontrolObject(PlaySimbolBlack);
                clearInterval(i);
            }
        }, 1000);



    function MusicTimeUpdate() {
        return(i);
    }


    function MusicPlayFunction(bgmNumber) {

        if(audio.paused == false) { 
            audio.pause();

            setTimeout(() => {
                audio.src = `/bgm/${bgmNumber}.mp3`;
                audio.play();
                setcontrolObject(PauseSimbolBlack);
                MusicTimeUpdate();
            }, 1000);
            
            return;
        }

        audio.src = `/bgm/${bgmNumber}.mp3`;
        audio.play();
        setcontrolObject(PauseSimbolBlack);
        MusicTimeUpdate();
    }


    function PlayButton() {

        if(audio.readyState == 0) {
            setcontrolObject(PauseSimbolBlack);
            MusicPlayFunction(musicNumber);
        return;
        } 

        if(audio.paused == false) {
            setcontrolObject(PlaySimbolBlack);
            audio.pause();
            return;
        }

        if(audio.paused == true) {
            setcontrolObject(PauseSimbolBlack);
            audio.play();
            MusicTimeUpdate();
            return;
        }

    }

    return(
        <Master>
            <TopRagnarok />
            <TopRagnarokBrasil />
                

            <AudioPlayer>

                <H2 >♪ RoStation ♫</H2>
                <MediaPlayerControlContainer>
                    <MediaPlayerControl onClick={() => PlayButton()} controlImage={controlObject}/>
                    <span>{musicName} - { musicDurationTimeLeft }</span>
                 </MediaPlayerControlContainer>
                <TrackListContainer>
                
                    { ThemeListRo().map(item => {
                        return(
                            <TrackContainer
                                onClick={() => {
                                    setMusicDuration(item.total_time);
                                    setMusicNumber(item.number);
                                    setMusicName(item.title);
                                    MusicPlayFunction(`${item.number}`);
                                    }}>
                                {item.title} - { item.number}
                            </TrackContainer>
                        )
                    })}
                </TrackListContainer>
                
            </AudioPlayer>
            <MusicalNoteSimbol bg={MusicalNoteGif}/>
        </Master>
    )
};

export default MusicPlayerMedia;

const Master = styled.div`
    display: flex;
    align-items: center;
    flex-direction: column;
    position: fixed;
    bottom: 10px;
    right: 30px;
    z-index: 30;
    //border: solid;

    &:hover {
    }

    @media (max-width: 1000px) {
    width: 99vw;
    position: static;
    align-items: center;
    overflow: hidden;
    }

`
const MusicalNoteSimbol = styled.div`
    background-image: url(${props => props.bg});
    background-position: center center;
    backrgound-repeat: no-repeat;
    background-size: cover;
    width: 100px;
    height: 100px;
    transition: .3s ease-in-out;
    //border: solid;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    scale: 1.1;
    }

    @media (max-width: 1000px) {
    width: 0px;
    height: 0px;
    }

`

const AudioPlayer = styled.div`
    //border: solid 1px;
    border-radius: 10px;
    width: 100%;
    height: 80px;
    overflow: hidden;
    transition: .3s ease-in-out;
    opacity: .5;
    display: flex;
    flex-direction: column;
    align-items: center;
    margin-bottom: 0px;
    padding: 10px;

    &:hover {
        padding: 10px;
        border-radius: 10px;
        width: 300px;
        height: 400px;
        opacity: 1;
        background-color: rgba(156, 5, 5, 1);
        color: white;
        scale: 1.2;
    
    }

    @media (max-width: 1000px) {
        width: 90vw;
        height: 400px;
        color: white;
        opacity: 1;
        padding: 0;
        align-items: center;
        overflow: auto;
        margin-top: 0px;
        //background-color: rgba(43, 41, 40, 1);

        &:hover {
            width: 90vw;
            height: 400px;
            opacity: 1;
            color: white;
            padding: 0px;
            //background-color: rgba(43, 41, 40, 1);
            scale: 1;
        }
    }
`

const H2 = styled.h2`
    text-align: center;
    margin: 0px;
    padding: 0;
    //border: solid;

    @media (max-width: 1000px) {
    width: 80vw;
    }


`

const MediaPlayerControlContainer = styled.div`
    display: flex;
    align-items: center;
    //border: solid;

    @media (max-width: 1000px) {
    width: 80vw;
    justify-content: start;
    scale: 1;
    margin-top: 20px;
    font-size: 14pt;
    }

`

const MediaPlayerControl = styled.div`
    background-image: url(${props => props.controlImage});
    background-size: cover;
    background-repeat: no-repeat;
    background-position: center center;
    width: 30px;
    height: 30px;
    margin-right: 20px;
    transition: .3s ease-in-out;
    //border: solid;

    cursor: url('cursors0007.png'), pointer;
    
    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
        scale: 1.5;
    }

     @media (max-width: 1000px) {
    width: 40px;
    height: 40px;

    &:hover {
        scale: 1.1;
    }
    }

`

const TrackListContainer = styled.div`
    margin: 20px 0;
    transition: .3s ease-in-out;
    display: flex;
    flex-direction: column;
    align-items: center;
    overflow: auto;
    width: 100%;
    min-height: 40px;
    //scrollbar-color: white;

    @media (max-width: 1000px) {
    width: 80vw;
    //border: solid 1px;
    //box-shadow: 2px 2px 5px 2px black;
    border-radius: 10px;
    
    }
`

const TrackContainer = styled.span`
    margin-bottom: 20px;
    transition: .3s ease-in-out;
    border-radius: 5px;
    padding: 2px 10px;
    //border: solid 1px;
    display: flex;

    cursor: url('cursors0007.png'), pointer;

    &:active {
        cursor: url('cursors0008.png'), pointer;
        
     }

    &:hover {
    background-color: white;
    color: black;
    //scale: 1.3;
    }

    @media (max-width: 1000px) {
        width: 60vw;
        opacity: 1;
        justify-content: left;
        font-size: 14pt;
        margin-bottom: 2px;

        &:hover {
        scale: 1.1;
    }
}
`



